/// <amd-module name="Wit/DeliveryPlans/Board/Graph/PathBuilder" />
import { IPoint } from "./Contracts";

/**
 * A simple utility which provider syntactic sugar to build a path.
 * There are no validation on the path.
 */
export class PathBuilder {
    private _pathBuilder: string = "";

    public start(from: IPoint): PathBuilder {
        this._pathBuilder += `M${from.x} ${from.y}`;
        return this;
    }

    public line(to: IPoint): PathBuilder {
        this._pathBuilder += ` L${to.x} ${to.y}`;
        return this;
    }

    public quadraticBezier(to: IPoint, controlPoint: IPoint): PathBuilder {
        this._pathBuilder += ` Q ${controlPoint.x} ${controlPoint.y} ${to.x} ${to.y}`;
        return this;
    }

    public arc(to: IPoint, radiusX: number, radiusY: number, largeArcFlag: number, sweepFlag: number) {
        this._pathBuilder += ` A ${radiusX} ${radiusY} 0 ${largeArcFlag} ${sweepFlag} ${to.x} ${to.y}`;
        return this;
    }

    public toString() {
        return this._pathBuilder;
    }
}
